import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TimelineMax, Power0 } from 'gsap'
import isString from 'lodash/isString'

import SlideHOC from '../SlideHOC'
import Video from './Video'
import ANIMATION_TYPES from '../../../../constants/animationTypes'

import './VideoScene.scss'

class VideoScene extends Component {

  defineAnimations () {
    this.inAnimation = new TimelineMax({ paused: true })
      .to(this.wrapperRef, 0, { xPercent: 0, rotationY: 0, immediateRender: false })
      .fromTo(this.rootRef, this.props.duration / 2, { autoAlpha: 0, scale: 0.5 },
        { scale: 1, autoAlpha: 1, ease: Power0.easeNone, delay: this.props.duration / 2 })

    this.inReversedAnimation = new TimelineMax({ paused: true })
      .fromTo(this.rootRef, this.props.duration / 2, { autoAlpha: 0, scale: 1 }, { autoAlpha: 1, zIndex: 10 })
      .fromTo(this.wrapperRef, this.props.duration / 2,
        { xPercent: -15, rotationY: 100, immediateRender: false }, { xPercent: 0, rotationY: 0 }, 0)

    this.outAnimation = new TimelineMax({ paused: true })
      .fromTo(this.rootRef, this.props.duration / 2, { zIndex: 1 }, { autoAlpha: 0 })
      .to(this.wrapperRef, this.props.duration / 2, { xPercent: -15, rotationY: 100 }, 0)

    this.outReversedAnimation = this.outAnimation
  }

  renderVideo () {
    const { video } = this.props
    const { currentAnimationType } = this
    if (isString(video)) {
      return (
        <iframe
          id='aw_video__video'
          className='aw_video__video-wrapper'
          src={`${video}?autoplay=1`}
        />
      )
    } else if (video.url) {
      return (
        <Video
          video={video.url}
          videoBg={video.thumbUrl}
          focused={currentAnimationType === ANIMATION_TYPES.IN || currentAnimationType === ANIMATION_TYPES.IN_REVERSED}
        />
      )
    } else {
      return (
        <img
          id='aw_video__video'
          className='aw_video__video-wrapper'
          src={video.thumbUrl}
        />
      )
    }
  }

  render () {
    const { title, description, onNext, button } = this.props
    return (
      <div className='aw_video' ref={ref => (this.rootRef = ref)}>
        <div className='aw_video__wrapper' ref={ref => (this.wrapperRef = ref)}>
          {this.renderVideo()}

          <div id='aw_video__title' className='aw_video__title'>
            {title}
          </div>
          <div className='aw_video__divider' />
          <div id='aw_video__description' className='aw_video__description'>
            <span className='aw_video__description--text'>{description}</span>
          </div>

          <div className='aw_video__button-wrapper'>
            <button id='aw_video__button' className='aw_video__button' onClick={onNext}>{button}</button>
          </div>
        </div>
      </div>
    )
  }

  static defaultProps = {
    animation: ANIMATION_TYPES.NONE,
    duration: 2,
  }

  static propTypes = {
    video: PropTypes.object,
    title: PropTypes.string,
    button: PropTypes.string,
    description: PropTypes.string,
    onNext: PropTypes.func,
    animation: PropTypes.oneOfType([PropTypes.string, PropTypes.object]), // eslint-disable-line react/no-unused-prop-types
    duration: PropTypes.number,
  }
}

export default SlideHOC(VideoScene)



// WEBPACK FOOTER //
// ./src/templates/app-website/components/video/VideoScene.js